// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__2dDCJ","normalElement":"styles_normalElement__CfC8W","inactive":"styles_inactive__a9I34"};